export const ingredients = [
  {
    id: 'main',
    items: [
      {
        name: 'Canola or vegetable oil',
        number: 2,
        unit: 'Tbsp'
      },
      {
        name: 'Garlic',
        number: 6,
        unit: 'cloves',
        preparation: 'minced'
      },
      {
        name: 'Red pepper flakes',
        number: 1,
        unit: 'tsp'
      },
      {
        name: 'Brown sugar',
        number: 1,
        unit: 'Tbsp'
      },
      {
        name: 'Soy sauce',
        number: 2,
        unit: 'Tbsp'
      },
      {
        name: 'Gochujang',
        number: 1,
        unit: 'Tbsp',
        note: 'optional'
      },
      {
        name: 'Noodles',
        number: 8,
        unit: 'oz',
        numberMetric: 225,
        unit: 'g'
      },
    ]
  },
  {
    id: 'toppings',
    name: 'Toppings',
    items: [
      {
        name: 'Scallions (green onions)',
        preparation: 'chopped'
      },
      { 
        name: 'Toasted sesame seeds' 
      },
      {
        name: 'Gochugaru',
        note: 'Korean chili flakes'
      }
    ]
  }
]